/**
 * Boards tab — localStorage key for Kanban/Scrum + table preference.
 */
export function getBoardSettingsStorageKey(projectSlug) {
  return `project-board-settings-${projectSlug ?? ""}`;
}
